import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOfferMigrateProductOptionsQuery = createQueryHook(
  OffersApiClient.migrationToAnotherProductOptions,
  {
    queryKey: ['offerMigrateProductOptions'],
  },
)
